module.exports = __webpack_public_path__ + "img/carsten_w.e3c4bb6c.jpeg";